(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mg-product-page')) {
  customElements.define('mg-product-page', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.models = JSON.parse(this.querySelector('[data-model-data]').textContent);
      this.bundlePrices = JSON.parse(this.dataset.bundlePrices);
      this.form = this.querySelector('.mgp-form');
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: this.dataset.currency || 'USD'});
      this.current = String(this.dataset.current);
      this.querySelectorAll('[data-pack] input[type="radio"]').forEach(radio => radio.addEventListener('change', () => this.activate(radio.value)));
      this.querySelectorAll('[data-model-select]').forEach(select => select.addEventListener('change', () => {
        const model = this.getModel(select.value);
        select.closest('.mgp-model-row').querySelector('img').src = model.thumb;
        if (select.dataset.position === '1') this.showModel(select.value);
        this.updateTotals();
      }));
      this.querySelectorAll('[data-gallery-model]').forEach(button => button.addEventListener('click', () => this.chooseModel(button.dataset.galleryModel)));
      this.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => {
        const index = this.models.findIndex(model => String(model.id) === this.current);
        const next = (index + Number(button.dataset.galleryStep) + this.models.length) % this.models.length;
        this.chooseModel(this.models[next].id);
      }));
      this.form.addEventListener('submit', event => this.addToCart(event));
      this.activate('1');
    }
    getModel(id) { return this.models.find(model => String(model.id) === String(id)); }
    activate(count) {
      this.querySelectorAll('[data-pack]').forEach(pack => {
        const active = pack.dataset.pack === String(count);
        pack.classList.toggle('is-active', active);
        pack.querySelectorAll('select').forEach(select => select.disabled = !active);
      });
      this.form.querySelector('[name="quantity"]').value = count;
      this.showModel(this.querySelector('.mgp-pack.is-active select').value);
      this.updateTotals();
    }
    chooseModel(id) {
      this.querySelectorAll('[data-model-select][data-position="1"]').forEach(select => {
        select.value = String(id);
        select.closest('.mgp-model-row').querySelector('img').src = this.getModel(id).thumb;
      });
      this.showModel(id);
      this.updateTotals();
    }
    showModel(id) {
      const model = this.getModel(id);
      if (!model) return;
      this.current = String(id);
      const image = this.querySelector('.mgp-main-image');
      image.removeAttribute('srcset'); image.src = model.image; image.alt = model.title;
      this.querySelector('[data-product-title]').textContent = model.title;
      this.querySelector('[data-product-price]').textContent = this.format.format(model.price / 100);
      this.querySelector('[data-product-compare]').textContent = this.format.format(model.compare / 100);
      this.querySelector('[data-selected-model]').textContent = model.title;
      this.querySelector('[data-product-description]').textContent = model.description;
      this.form.querySelector('[name="id"]').value = id;
      this.querySelectorAll('[data-gallery-model]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryModel === String(id))));
    }
    updateTotals() {
      this.querySelectorAll('[data-pack]').forEach(pack => {
        const total = this.bundlePrices[Number(pack.dataset.pack) - 1];
        pack.querySelector('[data-pack-total]').textContent = this.format.format(total / 100);
        if (pack.classList.contains('is-active')) this.querySelector('[data-selected-total]').textContent = this.format.format(total / 100);
      });
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy) return;
      this.busy = true;
      const button = this.form.querySelector('[type="submit"]');
      const label = button.querySelector('[data-add-text]');
      const error = this.querySelector('.mgp-error');
      error.hidden = true; button.disabled = true; label.textContent = this.dataset.adding;
      const amounts = new Map();
      this.querySelectorAll('.mgp-pack.is-active select').forEach(select => amounts.set(select.value, (amounts.get(select.value) || 0) + 1));
      const items = Array.from(amounts, ([id, quantity]) => ({id: Number(id), quantity}));
      try {
        const response = await fetch(this.dataset.addUrl, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || this.dataset.error; error.hidden = false;
        button.disabled = false; label.textContent = this.dataset.addLabel; this.busy = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
